import { PieChartIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PageSubHeaderBreadcrumbs } from '@/components/organisms/PageSubHeader/PageSubHeader';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/components/ui/breadcrumb';

export const DefaultAnalyticsBreadcrumb = () => {
  const { t } = useTranslation();

  return (
    <PageSubHeaderBreadcrumbs>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>
              <div className="flex h-8 w-8 items-center justify-center">
                <PieChartIcon size={16} className="text-foreground-muted" />
              </div>
              <div className="mr-4 ml-2 h-4 w-px bg-border" />
              {t('common.analytics')}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </PageSubHeaderBreadcrumbs>
  );
};
